import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import Arrow from '../assets/images/arrow-right-regular.svg';
import Download from '../assets/images/icon-download.svg';

export const HowItWorksSection = () => {
  return (
    <div className="howitworks-section">
      <div className="presenter-container">
        <div className="shadow-box">
          <div className="shadow-con-left">
            <div className="text-block-90">How Ark works</div>
            <div className="text-block-40">Download the App</div>
            <div className="text-block-25">
              Most things start easy, so does Ark.
              <br />
              Just download our app and sign up to our Service.
            </div>
            <div className="text-block-25 bold">
              Congratulations your are one step closer to fast
              <br />
              transactions!
            </div>
            <div className="row">
              <button style={{ outline: 'none' }} className="arrow-button-left">
                <img src={Arrow} loading="lazy" alt="" className="image-180-rotate" />
              </button>
              <button style={{ outline: 'none' }} className="arrow-button-right">
                <img src={Arrow} loading="lazy" alt="" className="image-6" />
              </button>
            </div>
          </div>
          <div className="howitworksgreenbox">
            <img src={Download} loading="lazy" height="" alt="" className="box-image-right" />
          </div>
        </div>
      </div>
    </div>
  );
};
